enum EnrollStatus {
	OPEN = "open",
	CLOSED = "closed",
	FULL = "full",
	WAITLIST = "waitlist",
}

export default EnrollStatus;
